export enum RecipientAction {
    Edit = 1,
    PairedDonors = 2,
    Toolbox = 3,
    PotentialDonors = 4,
    Order3gTissueTyping = 5,
    UtilizeBulkCheekSwab = 6,
    EnrollRecipientShieldAlready = 7,
    EnrollRecipientShield = 8,
    WaitListReplace = 9,
    VoucherDonor = 10,
    Delete = 11,
    ReprintRequisition = 12,
    ViewMicrosite = 13,
    Divider = -1
}